import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface ConfirmDialogModelProps {
  message: string;
  heading?: string;
  onConfirm: () => void;
  onCancel: () => void;
  btn1?: any,
  btn2?: any
}

const ConfirmDialogModel = ({
  message,
  heading,
  onConfirm,
  onCancel,
  btn1,
  btn2
}: ConfirmDialogModelProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Animate in after mount
    const timeout = setTimeout(() => {
      setVisible(true);
    }, 10); // allow paint before animating
    document.body.style.overflow = "hidden";

    return () => {
      clearTimeout(timeout);
      document.body.style.overflow = "";
    };
  }, []);

  return createPortal(
    <div className="fixed inset-0 z-[2147483647] flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity duration-200">
      <div
        className={`bg-white p-6 rounded-md w-[90%] max-w-md transform transition-all duration-700 ease-[cubic-bezier(0.25,1,0.5,1)] ${visible ? "opacity-100 scale-100" : "opacity-0 scale-90"
          }`}
      >

        {heading && <h2 className="text-base font-semibold mb-4">{heading}</h2>}
        <div>

          {message ? <h2 className="text-base mb-6 font-semibold modalTitle">
            {message}
          </h2>
            : ""}
          <div className="flex gap-2 justify-between">
            <button
              onClick={onCancel}
              className="border border-[#34558B] rounded-md text-[#34558B] font-semibold w-full p-3"
            >
              {btn1 || t("MyAddress.cancel")}
            </button>
            <button
              onClick={onConfirm}
              className="bg-[#34558B]  rounded-md text-white font-semibold w-full p-3"
            >
              {btn2 || t("MyAddress.delete")}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialogModel;
